<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M6 4.5A1.5 1.5 0 004.5 6v36A1.5 1.5 0 006 43.5h20a1.5 1.5 0 001.5-1.5v-8a1.5 1.5 0 00-3 0v6.5h-17v-33h17V14a1.5 1.5 0 003 0V6A1.5 1.5 0 0026 4.5H6zm31.06 12.44a1.5 1.5 0 00-2.12 2.12l3.439 3.44H18a1.5 1.5 0 000 3h20.379l-3.44 3.44a1.5 1.5 0 002.122 2.12l6-6a1.5 1.5 0 000-2.12l-6-6z"/></svg>